/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { QueryMeasures, QueryMeasures$inboundSchema } from "./querymeasures.js";

/**
 * A single time bucket within a series
 */
export type QueryPoint = {
  /**
   * Bucket start time in Unix nanoseconds (string for JS precision)
   */
  bucketTimeUnixNano: string;
  /**
   * Aggregated measure values for a group or time bucket
   */
  measures: QueryMeasures;
};

/** @internal */
export const QueryPoint$inboundSchema: z.ZodMiniType<QueryPoint, unknown> = z
  .pipe(
    z.object({
      bucket_time_unix_nano: z.string(),
      measures: QueryMeasures$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "bucket_time_unix_nano": "bucketTimeUnixNano",
      });
    }),
  );

export function queryPointFromJSON(
  jsonString: string,
): SafeParseResult<QueryPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryPoint' from JSON`,
  );
}
